import API from '@/views/Fdc/Apis/'
import _ from 'lodash'

/**
 *
 * Description : SPC Mail Manager JS
 * Author      : 송기태
 * Date        : 2021. 4. 29.
 * Version     : 1.0
 * Company     : Copyright ⓒ Brique C&C. All Right Reserved
 */
export default {
  name: 'mailManager',
  beforeMount () {
    this.initColumns()
  },
  mounted () {
    this.searchMailGroupList()
  },
  methods: {
    /**
     * @summary       : initColumns
     * @description   : Mail Group Grid Column Head Init
     * @Note        : Lable 사용은 기능 구현 후 en.js로 적용 할 것.
     */
    initColumns () {
      this.mailGroupColumns = [
        { headerName: 'Group ID', field: 'emailGroupId', checkboxSelection: true, headerCheckboxSelection: true, modifiable: false, required: true },
        { headerName: 'Group Description', field: 'emailGroupDesc', editable: true }
      ]
      this.mailUserColumns = [
        { headerName: 'User Group', field: 'emailGroupId', checkboxSelection: true, headerCheckboxSelection: true, required: true },
        { headerName: 'User E-Mail', field: 'emailAddr', required: true, modifiable: false },
        { headerName: 'User ID', field: 'userId', required: true, modifiable: false },
        { headerName: 'User Name', field: 'userName', required: true, modifiable: false }
      ]
    },
    /**
     * @summary       : initColumns
     * @description   : Mail Group Grid Column Head Init
     * @Param         : wijmo grid
     */
    initMailGroupGrd (grid) {
      this.codeTypeGrd = grid
    },
    /**
     * Code List Grid 초기화
     * @param {*} grid wijmo grid
     */
    initMailUserGrd (grid) {
      this.mailUser = grid
    },
    /**
     * Code Type 조회
     */
    async searchMailGroupList () {
      const groupList = await API.Model.getMailGroupList()
      this.mailGroupDataRowData = [...groupList]
      this.selectedMailGroupData = { ...groupList[0] }
      this.searchMailUserList()
    },
    /**
     * Code Type 조회 Callback
     * @param {Object} response Code type 조회 결과
     */
    mailGroupCallback (response) {
      if (response.status === 200 && response.data) {
        this.codeTypeDataRowData = response.data
      }
    },
    /**
     * Code 조회
     */
    async searchMailUserList () {
      const payload = { 'emailGroupId': this.selectedMailGroupData.emailGroupId }
      this.mailUserRowData = await API.Model.getMailGroupUserList(payload)
    },
    /**
     * Code Type 저장 후 row 설정
     * @param {*} e focus 할 row
     */
    setMailGroupLoadRow (e) {
      this.tmpCodeTypeSelLoadRow = {
        mailGroup: e.mailGroup
      }
    },
    /**
     * Code 저장 후 row 설정
     * @param {*} e focus 할 row
     */
    setMailUserLoadRow (e) {
      this.tmpCodeSelLoadRow = {
        codeType: e.codeType,
        codeId: e.codeIdz
      }
    },

    /**
     * Save Validation 체크 및 Data 생성
     * @param {*} grid
     * @returns {*} Validation 성공 여부, save row data, modify row data
     */
    saveValidCheck (ref, targetGrid) {
      const checkedRows = ref.getCheckedRows()
      const totalModifiedRows = ref.getUpdatedRows()
      const addedRows = ref.getAddedRows()

      let saveRows = []

      let result = {
        isValid: false,
        saveRows: saveRows,
        addedRows: addedRows,
        totalModifiedRows: totalModifiedRows
      }
      console.log('saveValidCheck - end', { result, checkedRows })
      // 선택된 데이터가 없습니다.
      if (checkedRows.length < 1) {
        this.$dialog.alert(this.T.M010)
        result.isValid = true
        return result
      }
      console.log('saveValidCheck - end', { result, checkedRows })
      checkedRows.some(row => {
        const rowStatus = row.briqueGridCud
        // 변경되어 선택된 저장 대상
        if (rowStatus === 'C' || rowStatus === 'U') {
          saveRows.push(row)
        }
      })
      console.log('saveValidCheck - end', { result, checkedRows })
      // 변경된 데이터가 없습니다.
      if (saveRows < 1) {
        // this.$dialog.alert(this.T.M011)
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_CHANGED'))
        result.isValid = true
        return result
      }
      console.log('saveValidCheck - end', { result, checkedRows })
      if (this.saveDataValidCheck(checkedRows, ref, targetGrid)) {
        result.isValid = true
        return result
      }
      console.log('saveValidCheck - end', { result, checkedRows })
      return result
    },
    /**
     * 컬럼 필수 저장 값 check
     * @param {*} checkedRows check된 row data
     * @param {*} ref $ref
     * @returns {Boolean} 체크 결과
     */
    saveDataValidCheck (checkedRows, ref, targetGrid) {
      const that = this
      return checkedRows.some(row => {
        const checkRequired = Object.keys(row).some(function (itemKey) {
          const column = ref.gridColumnApi.getColumn(itemKey)
          const colValue = row[itemKey]
          if (column !== null && column.colDef?.required) {
            if (that.isEmpty(colValue)) {
              that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', [column.colDef.headerName]))
              return true
            }
          }
        })
        // 필수값
        if (checkRequired) { return true }
        // 중복값
        var dupIdx = this.rowItemDupCheck(row, ref)
        if (dupIdx > 0) {
          this.tParam = ['[line ' + (dupIdx + 1) + '] ']
          this.$dialog.alert(this.T.M002)
          return true
        }
        if (ref.briqueGridId === 'BriqueGridmailUser') {
          let validationResult = this.mailTypeValidation(row, ref)
          if (validationResult.wrongTypeExists) {
            this.$dialog.alert('[line ' + (validationResult.emailIdx + 1) + '] Check Email Type') // 공통으로 옮길것
            return true
          }
        }
      })
    },
    /**
     * 중복 체크
     * @param {*} item row data
     * @param {*} grid wijmo grid
     * @returns {Boolean} 중복 체크 결과
     */
    _rowItemDupCheck (item, grid) {
      let flex = grid
      let dupIdx = 0
      flex.rows.some((row, idx) => {
        switch (flex.$attrs.name) {
          case 'mailGroupGrd':
            if (this.itemMailGroupDupCheck(item, row.dataItem)) {
              dupIdx = idx + 1
              return true
            }
            break
          case 'mailUser':
            if (this.itemMailUserDupCheck(item, row.dataItem)) {
              dupIdx = idx + 1
              return true
            }
            break
        }
      })
      return dupIdx
    },
    rowItemDupCheck (item, ref) {
      let dupIdx = 0
      const model = ref.gridApi.getModel()
      if (model) {
        const rowCount = model.getRowCount()
        for (let i = 0; i < rowCount; i++) {
          const rowNode = model.getRow(i)
          if (ref.briqueGridId === 'BriqueGridmailGroupGrd') {
            if (this.itemMailGroupDupCheck(rowNode.data, item)) {
              dupIdx = i
              break
            }
          } else {
            if (this.itemMailUserDupCheck(rowNode.data, item)) {
              dupIdx = i
              break
            }
          }
        }
      }
      return dupIdx
    },
    _mailTypeValidation (item, grid) {
      let flex = grid
      let dupIdx = 0
      flex.rows.some((row, idx) => {
        switch (flex.$attrs.name) {
          case 'mailUser':
            if (this.itemMailTypeCheck(item)) { // Mail 형식 체크
              dupIdx = idx + 1
              return true
            }
            break
        }
      })
      return dupIdx
    },
    mailTypeValidation (item, ref) {
      let wrongEmailTypeIdx = 0
      let wrongTypeExists = false
      const model = ref.gridApi.getModel()
      if (model) {
        const rowCount = model.getRowCount()
        for (let i = 0; i < rowCount; i++) {
          const rowNode = model.getRow(i)
          if (this.itemMailTypeCheck(rowNode.data) === true) {
            wrongEmailTypeIdx = i
            wrongTypeExists = true
            break
          }
        }
      }
      return { emailIdx: wrongEmailTypeIdx, wrongTypeExists }
    },
    /**
     * Code Type 중복 체크
     * @param {*} item row data (저장 항목)
     * @param {*} dataItem row data (기존 항목)
     * @returns {Boolean} 중복 체크 결과
     */
    itemMailGroupDupCheck (item, dataItem) {
      return !_.isEqual(item, dataItem) && item.emailGroupId === dataItem.emailGroupId
    },
    /**
     * Code 중복 체크
     * @param {*} item row data (저장 항목)
     * @param {*} dataItem row data (기존 항목)
     * @returns {Boolean} 중복 체크 결과
     */
    itemMailUserDupCheck (item, dataItem) {
      return !_.isEqual(item, dataItem) && item.emailGroupId === dataItem.emailGroupId && item.emailAddr === dataItem.emailAddr
    },
    /**
     * Email 형식 체크
     * @param {*} item row data (저장 항목)
     * @param {*} dataItem row data (기존 항목)
     * @returns {Boolean} 중복 체크 결과
     */
    itemMailTypeCheck (item) {
      let regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i
      if (regExp.test(item.emailAddr)) return false
      else return true
    },
    /**
     * Code Type 저장
     */
    async saveMailGroupData () {
      const valid = this.saveValidCheck(this.$refs.mailGroupGrd, this.mailGroupGrd)
      if (valid.isValid) {
        return
      }
      console.log('saveMailGroupData', { valid })

      let confirmMessage = ''
      if (!_.isEqual(valid.saveRows.length, (valid.addedRows.length + valid.totalModifiedRows.length))) {
        confirmMessage = this.$t('fdc.COMMON.MESSAGE.CONFIRM_UNCHECKED_CHANGED_DATA')
      }
      confirmMessage += this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')
      const that = this
      let payload = valid.saveRows
      this.$dialog.confirm({
        message: confirmMessage,
        confirmText: that.$t('fdc.COMMON.BUTTON.CONFIRM'),
        cancelText: that.$t('fdc.COMMON.BUTTON.CANCEL'),
        onConfirm: async function () {
          const responseData = await API.Model.saveMailGroup(payload)
          if (responseData != null && responseData.status === 200) {
            that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
            that.setMailGroupLoadRow(valid.saveRows[0])
            that.searchMailGroupList()
          } else {
            that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'))
          }
        }
      })
    },
    /**
     * Code 저장
     */
    async saveMailUser () {
      const valid = this.saveValidCheck(this.$refs.mailUser)
      if (valid.isValid) {
        return
      }
      console.log('saveMailUser', { valid })

      let confirmMessage = ''
      if (!_.isEqual(valid.saveRows.length, (valid.addedRows.length + valid.totalModifiedRows.length))) {
        confirmMessage = this.$t('fdc.COMMON.MESSAGE.CONFIRM_UNCHECKED_CHANGED_DATA')
      }
      confirmMessage += this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')
      const that = this
      let payload = valid.saveRows
      this.$dialog.confirm({
        message: confirmMessage,
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        onConfirm: async function () {
          const responseData = await API.Model.saveMailGroupUser(payload)
          if (responseData != null && responseData.status === 200) {
            that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
            that.setMailGroupLoadRow(valid.saveRows[0])
            that.searchMailUserList()
          } else {
            that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'))
          }
        }
      })
    },
    /**
     * Row Data 분류
     * @param {*} grid wijmo grid
     * @returns {*} data Object
     * grid에 row를 분류한다. (check row, add한 row, delete row)
     */
    deleteMailUserCollector (grid) {
      const allRows = grid.rows
      const checkedRows = allRows.filter(d => d.dataItem._status.checked)
      const addedRow = checkedRows.filter(d => d.dataItem._status.added)
      const deleteRowWithStatus = checkedRows.filter(d => !d.dataItem._status.added)
      let deleteRow = []
      deleteRowWithStatus.forEach(row => {
        // 데이터 삭제 할 로우
        const item = _.clone(row.dataItem)
        delete item['_status']
        deleteRow.push(item)
      })

      return {
        checkedRows: checkedRows,
        addedRow: addedRow,
        deleteRow: deleteRow
      }
    },
    deleteRowCollector (ref) {
      const checkedRows = ref.getCheckedRows()
      let addedRow = []
      let deleteRow = []

      checkedRows.some(row => {
        const rowStatus = row.briqueGridCud
        // 변경되어 선택된 저장 대상
        if (rowStatus !== 'C') {
          // 데이터 삭제 할 로우
          deleteRow.push(row)
        } else {
          // grid에서 그냥 삭제할 로우
          // FIXME: 필요 여부 판단
          addedRow.push(row)
        }
      })

      return {
        checkedRows: checkedRows,
        addedRow,
        deleteRow
      }
    },
    /**
     * Code Type 삭제
     */
    deleteMailGroupData () {
      const rowList = this.deleteRowCollector(this.$refs.mailGroupGrd)
      const that = this

      if (rowList.checkedRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
        return
      }

      const confirmMessage = this.T.M014_1 + this.T.M014
      const completeMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE')

      let payload = rowList.deleteRow

      console.log({ payload })

      this.$dialog.confirm({
        message: confirmMessage,
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        onConfirm: async function () {
          this.codeTypeDataRowData = []
          this.codeDataRowData = []
          if (rowList.deleteRow.length > 0) {
            await API.Model.deleteMailGroup(payload)
          }
          that.$dialog.alert(completeMessage)
          that.searchMailGroupList()
        }
      })
    },
    /**
     * Code 삭제
     */
    deleteMailUserData () {
      const rowList = this.deleteRowCollector(this.$refs.mailUser)
      const that = this
      if (rowList.checkedRows < 1) {
        this.$dialog.alert(this.T.M010)
      }

      const confirmMessage = this.T.M014
      const completeMessage = this.T.M015

      let payload = rowList.deleteRow

      this.$dialog.confirm({
        message: confirmMessage,
        confirmText: this.T.B005,
        cancelText: this.T.B006,
        onConfirm: async function () {
          this.codeDataRowData = []
          if (rowList.deleteRow.length > 0) {
            await API.Model.deleteMailGroupUser(payload)
          }
          that.$dialog.alert(completeMessage)
          that.searchMailUserList()
        }
      })
    },
    /**
     * Grid Cell Edit End event
     * @param {*} grid 대상 grid
     * @param {*} event 이벤트
     * 수정된 row 자동 check
     */
    async cellEditEnd (grid, event) {
      let col = grid.columns[event.col]
      let rowStatus = grid.rows[event.row]._data._status

      // modified and added row 시 자동 check (checkbox column 제외)
      if (col.binding !== '_status.checked') {
        if (rowStatus.modified || rowStatus.added) {
          rowStatus.checked = true
        } else {
          rowStatus.checked = false
        }
      }
    },
    /**
     * Code type에서 선택한 Row 설정
     * @param {*} row
     */
    setMailGroup (row) {
      console.log('setMailGroup', { row, emailGroupId: row?.emailGroupId })
      this.selectedMailGroupData = { ...row }
      if (row != null && row.emailGroupId) {
        this.searchMailUserList()
      } else {
        this.mailUserRowData = []
      }
    },
    /**
     * Code Type List grid 신규 행 추가
     */
    mailGroupNewRowAdd () {
      let newRow = {
        emailGroupId: '',
        emailGroupDesc: ''
      }
      this.$refs.mailGroupGrd.addRowOne(newRow)
      // this.selectZeroIndexRow(this.$refs.mailGroupGrd)
    },
    /**
     * Code List grid 신규 행 추가
     */
    mailUserNewRowAdd () {
      let newRow = {
        emailGroupId: this.selectedMailGroupData.emailGroupId,
        emailAddr: '',
        userId: '',
        userName: ''
      }
      this.$refs.mailUser.addRowOne(newRow)
      // this.selectZeroIndexRow(this.$refs.mailUser)
    },
    /**
     * 처음 인덱스 선택하는 함수, v0.5에서 체크박스가 선택된 채로 행이 추가되어서 구현함
     * * @param {$refs} Grid reference
     */
    selectZeroIndexRow (ref) {
      const node = ref.gridApi.getRowNode(0)
      if (node) node.setSelected(true)
    },
    /**
     * Code Type 선택 Row 상태 확인
     * @returns {Boolean} 선택된 row 있는지 여부
     */
    hasCodeTypeRow () {
      if (this.selectedMailGroupData === null) {
        return false
      } else if (Object.keys(this.selectedMailGroupData).length === 0) {
        return false
      } else if (this.selectedMailGroupData.briqueGridCud === 'C') {
        return false
      } else {
        return true
      }
    },
    /**
     * check된 row가 있는지 확인
     * @returns {*} check된 row 있는지 여부
     */
    hasCodeTypeCheckedRows () {
      if (!this.$refs.mailGroupGrd) {
        return 0
      }
      return this.$refs.mailGroupGrd.checkedRowCount > 0
    },
    /**
     * check된 row가 있는지 확인
     * @returns {*} check된 row 있는지 여부
     */
    hasCodeCheckedRows () {
      if (!this.$refs.mailUser) {
        return 0
      }
      return this.$refs.mailUser.checkedRowCount > 0
    },
    /**
     * Code Type List grid row select event
     * @param {*} grid wijmo grid
     * @param {*} e event
     */
    selectedRow (grid, e) {
      if (e.row === -1) return
      var currentRow = e.panel.rows[e.row]
      if (_.isEqual(e.row, e.panel._rng.row)) return
      if (!currentRow.dataItem._status.added) {
        console.log(currentRow)
        this.setMailGroup(currentRow.dataItem)
      } else {
        this.setMailGroup(null)
      }
    },
    onRowSelected (params) {
      if (params.node.selected) {
        if (params.node.data.briqueGridCud === 'C') {
          this.setMailGroup(null)
        } else {
          this.setMailGroup(params.node.data)
        }
      }
    },
    onFirstDataRendered (params) {
      const node = params.api.getRowNode(0)
      if (node) {
        this.setMailGroup(node.data)
      }
    },
    /**
     * null 값 check
     * @param {*} value check value
     */
    isEmpty (value) {
      if (value === '' || value === null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
        return true
      } else {
        return false
      }
    },
    onGridReady (params) {
      params.api.sizeColumnsToFit()
    }
  },
  data () {
    return {
      selectedMailGroupData: null, // 선택된 Code Type List grid row data
      selectedCodeData: null, // 선택된 Code List grid row data
      mailGroupColumns: [], // Code Type List grid columns 배열
      mailGroupDataRowData: [], // Code Type List grid row data
      mailUserColumns: [], // Code List grid columns 배열
      mailUserRowData: [], // Code List grid row data
      tmpCodeTypeSelLoadRow: {}, // Code Type List 재조회를 위한 data
      tmpCodeSelLoadRow: {}, // Code List 재조회를 위한 data
      tParam: [], // 다국어 message parameter data
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }
    }
  },
  computed: {
    T: function () {
      return {
        T001: this.$t('fdc.MANAGEMENT.TITLE.T0001'),
        T002: this.$t('fdc.MANAGEMENT.TITLE.T0002'),
        B001: this.$t('fdc.COMMON.BUTTON.REFRESH'),
        B002: this.$t('fdc.COMMON.BUTTON.ADD'),
        B003: this.$t('fdc.COMMON.BUTTON.SAVE'),
        B004: this.$t('fdc.COMMON.BUTTON.DELETE'),
        B005: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        B006: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        M001: this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', this.tParam),
        M002: this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', this.tParam),
        M004: this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'),
        M005: this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'),
        M010: this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'),
        M011: this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_CHANGED'),
        M012: this.$t('fdc.COMMON.MESSAGE.CONFIRM_UNCHECKED_CHANGED_DATA'),
        M013: this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE'),
        M014_1: this.$t('fdc.MANAGEMENT.MESSAGE.CONFIRM_DOWN_LEVEL_DELETE'),
        M014: this.$t('fdc.COMMON.MESSAGE.CONFIRM_DELETE'),
        M015: this.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE')
      }
    }
  }
}
